<template>
    <el-form label-width="180px" :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="名称" required>
            <el-input v-model="form.title" />
        </el-form-item>
        <el-form-item label="全部人数" required>
            <el-input v-model="form.lv0" />
        </el-form-item>
        <el-form-item label="直推人数" required>
            <el-input v-model="form.lv1" />
        </el-form-item>
        <el-form-item label="团队盈利" required>
            <el-input v-model="form.profit" />
        </el-form-item>
        <el-form-item label="盈利奖励（%）" required>
            <el-input v-model="form.profit_rate" />
        </el-form-item>
    </el-form>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue'
import { withdrawTypeEnums, getLabelByVal } from '@/config/enums'

const form = ref({
    title: "",
    lv0: "",
    lv1: "",
    profit: "",
    profit_rate: "",
})
const props = defineProps(['item'])

onMounted(() => {
    nextTick(() => {
        form.value = Object.assign(form, props.item)
    })
})

defineExpose({ form })

</script>

<style lang="less" scoped>
.demo-form-inline {
    justify-content: flex-start;
    display: flex;
    flex-wrap: wrap;
}

.demo-form-inline .el-input {
    --el-input-width: 220px;
}

.demo-form-inline .el-select {
    --el-select-width: 220px;
}

/deep/ .el-radio-group {
    width: 220px;
}

.form-title {
    text-align: left;
    padding-left: 30px;
    margin: 20px auto 10px;
    height: 44px;
    background-color: #f2f2f2;
    border-radius: 5px;
    line-height: 44px;
    width: 100%;
}

/deep/ .el-form-item {
    align-items: flex-start;
}
</style>